const backendFr = {
  auth_not_authenticated: 'Veuillez vous connecter pour continuer.',
  auth_permission_denied_add_org: "Vous n'avez pas l'autorisation d'ajouter une organisation.",
  payload_missing_required_fields: 'Certaines informations obligatoires sont manquantes.',
  organisation_invalid_type: "Le type d'organisation n'est pas valide.",
  organisation_duplicate_owner_name: "Une organisation portant ce nom existe déjà.",
  organisation_create_failed: "Impossible de créer l'organisation.",
  organisation_set_claims_failed_owner: "Impossible de mettre à jour les autorisations du propriétaire.",
  organisation_set_claims_failed_user: "Impossible de mettre à jour les autorisations de l'utilisateur.",
  organisation_add_failed: "Impossible d'ajouter l'organisation.",
  organisation_not_found: "Impossible de trouver cette organisation.",
  organisation_missing_fields: "Les informations de l'organisation sont incomplètes.",
  onboarding_not_new_user: 'Ce compte a déjà terminé l’onboarding.',
  onboarding_unknown_error: "Une erreur est survenue lors de la finalisation de l’onboarding.",
  email_invalid_argument: 'Saisissez une adresse e-mail valide.',
  email_already_verified: 'Cette adresse e-mail est déjà vérifiée.',
  email_no_data: "Impossible de préparer l'e-mail de vérification.",
  email_sending_failed: "Impossible d'envoyer l'e-mail. Réessayez plus tard.",
  email_verification_failed: "Impossible d'envoyer un nouvel e-mail de vérification.",
  promoter_not_found: "Impossible de trouver ce promoteur.",
  promoter_missing_claims: 'Le profil du promoteur est incomplet.',
  password_strength_failed: 'Choisissez un mot de passe plus robuste qui respecte toutes les exigences.',
  invitation_invalid_token: "Votre lien d'invitation est invalide ou a expiré. Veuillez ouvrir l'e-mail d'invitation le plus récent.",
  invitation_not_found: "Impossible de trouver cette invitation.",
  invitation_not_pending: "Cette invitation n'est plus en attente.",
  invitation_missing_id: "La référence de l'invitation est manquante.",
  invitation_public_cancel_denied: "Les invitations publiques ne peuvent pas être annulées.",
  invitation_not_inviter: "Seul l'invitant peut gérer cette invitation.",
  invitation_not_inviter_or_delegate: "Seuls l'invitant ou son délégué peuvent gérer cette invitation.",
  invitation_promoter_not_public: "Ce promoteur n'accepte pas les invitations publiques.",
  invitation_invalid_email_format: 'Saisissez une adresse e-mail et un mot de passe valides.',
  invitation_invalid_role_division: "Le rôle ou la division sélectionné n'est pas autorisé.",
  invitation_already_accepted: "Cette personne a déjà accepté une invitation.",
  invitation_email_in_use: 'Cette adresse e-mail est déjà enregistrée.',
  invitation_create_failed: "Impossible de créer l'invitation.",
  invitation_create_user_failed: "Impossible de créer le compte utilisateur.",
  invitation_create_user_ref_failed: "Impossible de lier le compte utilisateur.",
  invitation_inviter_data_failed: "Impossible de charger les informations de l'invitant.",
  invitation_inviter_claims_failed: "Impossible de charger les autorisations de l'invitant.",
  invitation_custom_claims_too_large: "Les autorisations de l'invitation sont trop volumineuses.",
  invitation_invite_permission_denied: "Vous n'avez pas l'autorisation d'inviter quelqu'un.",
  invitation_fetch_failed: "Impossible de charger les invitations.",
  invitation_user_missing_email: 'Votre compte doit comporter une adresse e-mail.',
  invitation_owner_missing: "Impossible de trouver le propriétaire du promoteur.",
  invitation_role_not_authorized: "Ce rôle n'est pas autorisé pour les invitations.",
  invitation_role_not_found: "Impossible de trouver ce rôle.",
  invitation_pending_exists: 'Une invitation est déjà en cours pour cette personne.',
  invitation_cancel_unknown: "Impossible d'annuler l'invitation.",
  invitation_reject_unknown: "Impossible de refuser l'invitation.",
  invitation_request_unknown: "Impossible d'envoyer la demande d'invitation.",
  verify_email_unknown: "Impossible de vérifier l'e-mail.",
  superuser_unauthorized: 'Seuls les super-utilisateurs peuvent effectuer cette action.',
  superuser_invitations_unknown: "Impossible de charger la liste des invitations.",
  superuser_users_unknown: "Impossible de charger la liste des utilisateurs.",
  superuser_organisations_unknown: "Impossible de charger la liste des organisations.",
  signup_requires_auth: 'Veuillez vous connecter pour continuer.',
  signup_unknown_error: "Une erreur est survenue lors de la création du compte.",
  signup_update_password_failed: "Impossible de mettre à jour le mot de passe.",
  provider_already_exists: 'Ce fournisseur existe déjà.',
  custom_claims_set_failed: "Impossible de mettre à jour les autorisations du compte.",
} as const;

export default backendFr;
